(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('operazione', {
            parent: 'entity',
            url: '/operazione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.operazione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/operazione/operaziones.html',
                    controller: 'OperazioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('operazione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('operazione-detail', {
            parent: 'entity',
            url: '/operazione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.operazione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/operazione/operazione-detail.html',
                    controller: 'OperazioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('operazione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Operazione', function($stateParams, Operazione) {
                    return Operazione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'operazione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('operazione-detail.edit', {
            parent: 'operazione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/operazione/operazione-dialog.html',
                    controller: 'OperazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Operazione', function(Operazione) {
                            return Operazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('operazione.new', {
            parent: 'operazione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/operazione/operazione-dialog.html',
                    controller: 'OperazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                codice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('operazione', null, { reload: 'operazione' });
                }, function() {
                    $state.go('operazione');
                });
            }]
        })
        .state('operazione.edit', {
            parent: 'operazione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/operazione/operazione-dialog.html',
                    controller: 'OperazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Operazione', function(Operazione) {
                            return Operazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('operazione', null, { reload: 'operazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('operazione.delete', {
            parent: 'operazione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/operazione/operazione-delete-dialog.html',
                    controller: 'OperazioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Operazione', function(Operazione) {
                            return Operazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('operazione', null, { reload: 'operazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
